import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["label"],
  _excluded2 = ["label"],
  _excluded3 = ["contextual", "use", "label"];
import styled from 'foundations-theming/utils';
import { LoadingDots } from '../LoadingDots';
import { LoadingSpinner } from '../LoadingSpinner';
import { Overlay } from '../Overlay';
import { jsx as _jsx } from "react/jsx-runtime";
const OverlayInnerWrapper = styled.div.withConfig({
  displayName: "LoadingOverlay__OverlayInnerWrapper",
  componentId: "sc-1cwi6ap-0"
})(["display:flex;justify-content:center;align-items:center;height:100%;"]);
const DEFAULT_USE = 'spinner';
const USE_VARIANTS = {
  dots: {
    Component(_ref) {
      let {
          label
        } = _ref,
        rest = _objectWithoutPropertiesLoose(_ref, _excluded);
      return /*#__PURE__*/_jsx(LoadingDots, Object.assign({}, rest, {
        title: label
      }));
    }
  },
  spinner: {
    Component(_ref2) {
      let {
          label
        } = _ref2,
        rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
      return /*#__PURE__*/_jsx(LoadingSpinner, Object.assign({}, rest, {
        label: label
      }));
    }
  }
};
export const LoadingOverlay = _ref3 => {
  let {
      contextual,
      use = DEFAULT_USE,
      label
    } = _ref3,
    rest = _objectWithoutPropertiesLoose(_ref3, _excluded3);
  const Loader = (USE_VARIANTS[use] || USE_VARIANTS[DEFAULT_USE]).Component;
  return /*#__PURE__*/_jsx(Overlay, {
    centerContent: true,
    contextual: contextual,
    use: "light",
    width: "auto",
    children: /*#__PURE__*/_jsx(OverlayInnerWrapper, {
      children: /*#__PURE__*/_jsx(Loader, Object.assign({}, rest, {
        label: label
      }))
    })
  });
};